import Cookies from 'js-cookie';

export const recoverSessionId = () => {
  const url = new URL(window.location.href);
  const override = url.searchParams.get('sessionId');
  if (override) {
    Cookies.set('sessionId', override, { sameSite: 'lax' });
    // Consume the param (one-shot) so a later Start Over (#new) is not overridden
    // by a stale ?sessionId lingering in the URL.
    url.searchParams.delete('sessionId');
    window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    return override;
  }
  if (window.location.hash === '#new') {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
    Cookies.remove('sessionId');
    return undefined;
  }
  return Cookies.get('sessionId');
};

/**
 * Reopen the builder on a specific (e.g. cloned) session by navigating with a
 * ?sessionId= param and no #new hash. On load recoverSessionId picks the param
 * up first (before the cookie / #new), loads that session's state and strips the
 * param. Used by "Save and Copy" to reopen the wizard pre-filled with the copied
 * config from the first step.
 */
export const reloadWithSession = (sessionId: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set('sessionId', sessionId);
  url.hash = '';
  window.location.href = url.toString();
};

export default recoverSessionId;
